<template>
    <div class="buttons has-addons is-centered">
        <b-button v-for="action in actions"
                  :key="'action-'+action+'-'+item.id"
                  tag="router-link" size="is-small"
                  :type="getButtonType(action)"
                  :to="getActionUrl(action)" :icon-left="iconMap[action]"></b-button>
    </div>
</template>

<script>
    export default {
        props: {
            actions: {
                type: Array,
                required: true
            },
            item: {
                type: Object,
                required: true
            },
            model: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                actionMap: {
                    view: 'show',
                    edit: 'edit',
                    delete: 'delete'
                },
                iconMap: {
                    view: 'eye',
                    edit: 'pencil'
                },
                needsId: ['view', 'edit']
            }
        },
        methods: {
            getActionUrl(action) {
                return '/' + this.model + '/' + this.actionMap[action] + '/' + this.item.id;
            },
            getButtonType(action) {
                if(action === 'view') return 'is-primary';
                if(action === 'delete') return 'is-danger';

                return 'is-info';
            }
        }
    }
</script>
